import { Stack, Typography } from "@mui/material";
import React from "react";

const CommunicationWaysTextWrapper = ({ label, value }) => {
  return (
    <>
      <Stack justifyContent="center" alignItems="flex-start">
        <Typography variant="body2" color="text.primary" fontWeight="fontWeightRegular">
          {label}:
        </Typography>
        <Typography variant="body1" color="text.primary" sx={{ direction: "rtl" }}>
          {value}
        </Typography>
      </Stack>
    </>
  );
};

export default CommunicationWaysTextWrapper;
